import React from 'react';
import { useMutation } from '@apollo/client';
import { CoherencePanel, CoherencePanelSize } from '@coherence-design-system/controls';
import { useForm } from 'react-hook-form';
import { IEntityTerminationReviewRejection } from '../types';
import { CoherencePanelStyles } from '../../../app/common/styles/CommonStyleObjects';
import ActionButtons from '../../common/ActionButtons';
import { REJECT_ENTITY_TERMINATION_ELIGIBILITY_REVIEW } from '../../../utils/statApi/EntityTerminationApi';
import LoadingErrorMessage from '../../common/errorContent/LoadingErrorMessage';
import EntityTerminationReviewRejectForm from './EntityTerminationReviewRejectForm';

interface IEntityTerminationReviewRejectPanelProps {
  closePanel: () => void;
  data: IEntityTerminationReviewRejection;
}

const EntityTerminationReviewRejectPanel: React.FC<IEntityTerminationReviewRejectPanelProps> = ({
  closePanel,
  data,
}) => {
  const form = useForm<IEntityTerminationReviewRejection>();
  const { handleSubmit, watch } = form;

  const lifecycleStatus = watch('lifecycleStatus');

  const [rejectEntityTerminationReview, { loading, error }] = useMutation(
    REJECT_ENTITY_TERMINATION_ELIGIBILITY_REVIEW,
    {
      onCompleted: () => {
        closePanel();
      },
    },
  );

  const handleSaveClick = (formData: IEntityTerminationReviewRejection): void => {
    rejectEntityTerminationReview({
      variables: {
        eligibilityReviewInputDto: {
          reviewId: data.reviewId,
          approvalId: data.review.reviewApprovals[0]?.id,
        },
        lifecycleStatusId: formData.lifecycleStatus?.id,
      },
    });
  };

  const isSaveDisabled = !lifecycleStatus?.fieldName?.trim();

  return (
    <CoherencePanel
      panelSize={CoherencePanelSize.medium}
      titleText="Reject Request"
      isOpen
      onDismiss={closePanel}
      styles={CoherencePanelStyles}
      hasCloseButton
      onRenderFooter={(): JSX.Element => (
        <ActionButtons
          closePanel={closePanel}
          saveLabel="Reject Request"
          saveTitle="Reject Request"
          cancelLabel="Cancel"
          cancelTitle="Cancel"
          handleSubmit={handleSubmit(handleSaveClick)}
          disabled={isSaveDisabled}
        />
      )}
    >
      <form>
        <LoadingErrorMessage error={error} loading={loading} />
        <EntityTerminationReviewRejectForm form={form} data={data} />
      </form>
    </CoherencePanel>
  );
};

export default EntityTerminationReviewRejectPanel;
